import { render, staticRenderFns } from "./navigationManagement.vue?vue&type=template&id=183ea0ee&scoped=true"
import script from "./navigationManagement.vue?vue&type=script&lang=js"
export * from "./navigationManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183ea0ee",
  null
  
)

export default component.exports